function baidu() {
  var _hmt = _hmt || [];
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?ed5e65d536523fa0a5d82dbbf419a776";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
}

export default{
    install: function (Vue) {
        Vue.prototype.$baidu = () => baidu()
    },
}


// WEBPACK FOOTER //
// ./src/common/js/baidu.js